export default "__VITE_ASSET__69a8738c__"